export default function percentChange(a, b) {
	//return 100 * (a - b) / ((a + b) / 2)
	//? Typically B is the actual or this year.  A is the projected/previous etc
	return ((b - a) / a) * 100
}